import _ from 'lodash';
import BigNumber from 'bignumber.js';
import { inThanMinOrMax, numberFormat } from 'wetrade-tools';
const $bn = BigNumber;
// 饼图图例处理
export function pieLegendFormatter(ev) {
    const { props } = ev;
    let tarValue = 0;
    const tarObj = ev.list.find(t => {
        return t.name === ev?.name; //获取当前value
    });
    tarValue = tarObj.value;
    //获取当前占比
    const ratio = props.isValueComputed
        ? tarValue
        : new $bn(ev.total > 0
            ? new $bn(tarValue).div(ev.total).toNumber()
            : new $bn(1).div(ev.list.length).toNumber())
            .times(100)
            .toNumber();
    const arr = [
        '{a|' + ev?.name + '}',
        props.originalValue
            ? '{b|' +
                inThanMinOrMax({
                    value: tarValue,
                    decimal: props.digits,
                    sign: props.showThousandSign,
                }) +
                '}'
            : '',
        props.accountedFor
            ? '{c|' +
                inThanMinOrMax({
                    value: ratio || 0,
                    decimal: props.digits,
                    isPercent: true,
                }) +
                '}'
            : '',
    ];
    const res = arr.join('');
    return res;
}
// 饼图tooltip浮层处理
export function pieTooltipFormatter(ev) {
    const { props } = ev;
    let name = ev.v?.name;
    const findIndexs = name?.indexOf('[');
    if (findIndexs > -1 && props.isLabelRemoveId) {
        name = name?.substring(0, findIndexs);
    }
    const symbolVal = props.originalValue || props.accountedFor ? '：' : '';
    // 自定义，显示原值，值为null则不显示，需要外层处理好数值
    if (props.customTooltip) {
        const list = `<div>` +
            `<i style="background-color: ${ev.v?.color};display: inline-block;width: 8px;height: 8px;border-radius: 50%; margin-right: 6px; vertical-align: middle;"></i>` +
            `<span style="display: inline-block; line-height: 18px; vertical-align: middle;">` +
            `${name}` +
            `${props.originalValue && !_.isNil(ev.v?.value) ? symbolVal + '&nbsp;' + ev.v?.value : ''}` +
            `${props.accountedFor && !_.isNil(ev.v?.data?.percent)
                ? '&nbsp;&nbsp;' + (ev.v?.data?.percent || '')
                : ''}` +
            `</span></div>`;
        return `<div class="all_tooltip">${list}</div>`;
    }
    else if (props.toolTipPatchFunc) {
        // 是否自定义tooltip
        return props.toolTipPatchFunc(ev.v);
    }
    //获取当前占比
    let tarValue = 0;
    const tarObj = ev.list.find(t => t.name === ev.v?.name);
    tarValue = tarObj?.value || 0;
    const ratio = props.isValueComputed
        ? tarValue
        : (ev.total > 0 ? new $bn(tarValue).div(ev.total) : new $bn(1).div(ev.list.length))
            .times(100)
            .toNumber();
    const list = `<div>` +
        `<i style="background-color: ${ev.v.color}; display: inline-block;width: 8px;height: 8px;border-radius: 50%; margin-right: 6px; vertical-align: middle;"></i>` +
        `<span style="display: inline-block;line-height: 18px;vertical-align: middle;">` +
        `${name}${symbolVal} ${props.originalValue
            ? ev.v?.value < 0.01 && ev.v?.value > 0
                ? '<0.01'
                : numberFormat(ev.v?.value, {
                    decimal: props.digits,
                    t: props.showThousandSign,
                }) + props.unit
            : ''}` +
        `${props.accountedFor
            ? '&nbsp;&nbsp;' +
                inThanMinOrMax({
                    value: ratio,
                    decimal: props.digits,
                    isPercent: true,
                })
            : ''}` +
        `</span> </div>`;
    return `<div class="all_tooltip">${list}</div>`;
}
